// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchant-queue{height:25px;width:30px;background-color:var(--main-brand-color);position:relative}.merchant-queue.empty{background-color:var(--brand-green-2)}.merchant-queue p{color:white;position:absolute;top:50%;left:50%;margin:0 -50% 0 0;transform:translate(-50%, -50%)}\n", ""]);
// Exports
module.exports = exports;
